"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentfulApiClient = void 0;
const config_json_1 = require("./config.json");
const contentful_1 = require("./shared/utils/contentful");
class ContentfulApiClient {
    constructor(space, env, options) {
        this.space = space;
        this.env = env;
        const urls = config_json_1.baseUrls;
        this.baseUrl = urls[this.env];
        this.options = options || {};
    }
    query(contentType, field, value, op = "eq") {
        return __awaiter(this, void 0, void 0, function* () {
            const query = {
                queries: [
                    {
                        field,
                        value,
                        op,
                    },
                ],
            };
            const resp = yield this.entries(contentType, query);
            return resp;
        });
    }
    entries(contentType, query) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield (0, contentful_1.getEntries)(this.space, this.baseUrl, contentType, query, this.options.additionalHeaders);
            return resp.data;
        });
    }
}
exports.ContentfulApiClient = ContentfulApiClient;
